import { render } from "./attendee.badge.vue?vue&type=template&id=4f8ad304"
import script from "./attendee.badge.vue?vue&type=script&lang=js"
export * from "./attendee.badge.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__